<template>
  <v-container fluid>
    <v-dialog v-model="visible" max-width="35%" @input="closeDialog">
      <v-card>
        <v-card-title>
          {{ showDevicePairingQr? $t('devices.download.configInfo') : $t('devices.download.title') }}
        </v-card-title>
        <v-card-text>
          {{ showDevicePairingQr? $t('devices.download.subheaderConfig') : $t('devices.download.subheader') }}
        </v-card-text>

        <template v-if="showDevicePairingQr">
          <v-card class="py-16 text-center">
            <qrcode-vue :value="qrCodeHostValue" :size="qrCodeSize" :level="qrCodeLevel"></qrcode-vue>
            <v-card-text class="mt-12">
              <v-card-text> {{ $t('devices.pairing.noAppYet') }} <a id="download_app_link" @click="showDevicePairingQr = false"> {{ $t('devices.pairing.downloadHere') }}</a></v-card-text>
            </v-card-text>
          </v-card>
        </template>
        <template v-if="!showDevicePairingQr">
          <v-container>
            <v-tabs-items v-model="tab">
              <v-tab-item key="1" value="android" :transition="false">
                <v-card flat>
                  <v-card-text class="text-center">
                    <qrcode-vue class="py-10" :value="qrCodeAndroidValue" :size="qrCodeSize" :level="qrCodeLevel"></qrcode-vue>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="2" value="apple" :transition="false">
                <v-card flat>
                  <v-card-text class="text-center">
                    <qrcode-vue class="py-10" :value="qrCodeIphoneValue" :size="qrCodeSize" :level="qrCodeLevel"></qrcode-vue>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
            <v-tabs
              v-if="!showDevicePairingQr" v-model="tab" class=""
              background-color="transparent"
              color="black"
              centered
              hide-slider
            >
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#android">
                {{ $t('devices.download.android') }}
              </v-tab>
              <v-tab href="#apple">
                {{ $t('devices.download.iphone') }}
              </v-tab>
            </v-tabs>
          </v-container>
        </template>
        <v-card-actions>
          <v-btn v-if="!showDevicePairingQr" class="v-btn-back text-center" @click="showDevicePairingQr = true">
            {{ $t('main.back') }}
          </v-btn>
          <v-btn id="done_button" color="primary" class="v-btn-done text-center" @click="doneClick">
            {{ showDevicePairingQr? $t('main.done') : $t('main.next') }}
          </v-btn>
        </v-card-actions>

        <v-spacer />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'AddDevice',

  components: {
    QrcodeVue
  },

  data() {
    return {
      visible: true,
      deviceFormValid: false,
      minCharacters: 4,
      maxCharacters: 255,
      showDevicePairingQr: true,
      tab: 'android',
      qrCodeAndroidValue: this.$store.state.remoteConfig.sicAndroidLink,
      qrCodeIphoneValue: this.$store.state.remoteConfig.sicIphoneLink,
      qrCodeHostValue: '{"url": "' + this.$store.state.remoteConfig.rsspApiUrl + '"}',
      qrCodeSize: 250,
      qrCodeLevel: 'M',
      rules: {
        required: (v) => !!v || !isNaN(parseFloat(v)) || this.$t('validation.form.requiredField'),
        minMax: (v) => ((v && v.length >= this.minCharacters) && (v && v.length <= this.maxCharacters)) || this.$t('validation.form.mustBeBetween', { min: this.minCharacters, max: this.maxCharacters })
      }
    }
  },

  methods: {
    doneClick() {
      if (this.showDevicePairingQr === false) {
        this.tab = false
        this.showDevicePairingQr = true
      } else {
        this.showDevicePairingQr = false
        this.tab = 'android'
        this.visible = false
        this.back()
      }
    },

    showDownloadQr() {
      this.showDevicePairingQr = true
    },

    closeDialog(e) {
      if (!e) {
        this.$router.go(-1)
      }
    },

    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

.theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active),
.theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon,
.theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-btn,
.theme--dark.v-tabs > .v-tabs-bar .v-tab--disabled {
  color: #a3a3a3 !important;
}
</style>
